import { Signal } from "@angular/core";
import { ViewDataCache } from "./view-data-cache";
import { Refresher } from "./refresher";
import { CRUDRepository, Identifiable, Page, PageQueryConfig } from "../../03_model/repository.model";
import { paginationData, PaginationData } from "../../02_ui/paginated-list-simple/paginated-list-simple.component";

export interface ViewService<T> {

  cache?: ViewDataCache;
  refresher?: Refresher;
  repo?: unknown;

  activateViewIdentity(id: string): Signal<T|PageViewModel<T>>;
  deactivateViewIdentity(id: string): void;

}


export type PageViewModel<T> = {
  data: T[];
  queryParameters: PageQueryConfig;
  pagination: PaginationData<T>;
}

export interface CRUDViewService<T extends Identifiable> {

  cache?: ViewDataCache;
  refresher?: Refresher;
  repo?: CRUDRepository<T>;

  activateViewIdentity(id: string): Signal<T|Page<T>>;
  deactivateViewIdentity(id: string): void;

}


export const DEFAULT_QUERY_PARAMETERS: PageQueryConfig = {
  searchParameters: [],
  sortKey: 'createdAt',
  sortDirection: 'desc'
};

export function emptyPageViewModel<T>(): PageViewModel<T> {
  return {
    data: [],
    queryParameters: { ...DEFAULT_QUERY_PARAMETERS },
    pagination: paginationData<T>()
  };
}
